import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getHistory } from '../api/assessment';
import PageLayout from '../components/PageLayout';
import Card from '../components/Card';
import { clearAll as clearPendingReports } from '../utils/pendingReports';

const GRADE_COLOR = {
  // V4 等级
  '初阶':'#d97706','进阶':'#2563eb','熟练':'#16a34a','高阶':'#7c3aed',
  // V5 L 级中文标签（与 V4 同色阶对齐）
  '知晓尝试级':'#d97706','基础应用级':'#2563eb','协同优化级':'#16a34a','创新引领级':'#7c3aed',
};

export default function HistoryPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getHistory().then(({ data }) => setList(data)).catch(() => {}).finally(() => setLoading(false));
    // 进入历史记录页：清空顶导气泡（pending + ready 一起清）。
    clearPendingReports();
  }, []);

  return (
    <PageLayout>
      <div style={{maxWidth:720,margin:'0 auto',padding:'48px 20px'}}>
        <h1 style={{fontSize:24,fontWeight:700,marginBottom:8}}>历史测评记录</h1>
        <p style={{color:'var(--color-text-secondary)',marginBottom:32,fontSize:14}}>每次测评记录永久保留，不覆盖历史数据</p>
        {loading ? (
          <p style={{color:'var(--color-text-muted)'}}>加载中...</p>
        ) : list.length === 0 ? (
          <Card style={{textAlign:'center',padding:48}}>
            <p style={{color:'var(--color-text-muted)',marginBottom:24}}>暂无历史测评记录</p>
            <Link to="/assessment/rules" style={{color:'var(--color-secondary)',fontWeight:600}}>开始第一次测评 →</Link>
          </Card>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {list.map(a => (
              <Card key={a.id} padding={20} style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:16}}>
                <div>
                  <div style={{fontSize:13,color:'var(--color-text-muted)',marginBottom:4}}>
                    {new Date(a.completed_at).toLocaleString('zh-CN')} · {a.depth_display}
                  </div>
                  <div style={{display:'flex',alignItems:'center',gap:12}}>
                    <span style={{fontSize:22,fontWeight:800,color:'var(--color-primary)'}}>
                      {a.score ?? '--'} <span style={{fontSize:14,fontWeight:400}}>分</span>
                    </span>
                    {a.grade && (
                      <span style={{padding:'3px 10px',borderRadius:20,fontSize:12,fontWeight:600,
                        background:`${GRADE_COLOR[a.grade]}20`,color:GRADE_COLOR[a.grade]}}>
                        {a.grade}
                      </span>
                    )}
                  </div>
                </div>
                <Link to={'/report/v5/'+a.id} style={{
                  padding:'8px 18px',borderRadius:'var(--radius-sm)',fontSize:13,fontWeight:600,
                  background:'var(--color-primary-light)',color:'var(--color-primary)',
                }}>查看报告</Link>
              </Card>
            ))}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
